/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_HatInputs */

const en_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hat`)
};

const es_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sombrero`)
};

const fr_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapeau`)
};

const de_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hut/Mütze`)
};

const ja_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帽子`)
};

const zh_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帽子`)
};

const ar_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبعة`)
};

const id_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topi`)
};

const it_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cappello`)
};

const ru_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шапка/Шляпа`)
};

const pt_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapéu / Boné`)
};

const ko_val_hat = /** @type {(inputs: Val_HatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모자`)
};

/**
* | output |
* | --- |
* | "Hat" |
*
* @param {Val_HatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_hat = /** @type {((inputs?: Val_HatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_HatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_hat(inputs)
	if (locale === "es") return es_val_hat(inputs)
	if (locale === "fr") return fr_val_hat(inputs)
	if (locale === "de") return de_val_hat(inputs)
	if (locale === "ja") return ja_val_hat(inputs)
	if (locale === "zh") return zh_val_hat(inputs)
	if (locale === "ar") return ar_val_hat(inputs)
	if (locale === "id") return id_val_hat(inputs)
	if (locale === "it") return it_val_hat(inputs)
	if (locale === "ru") return ru_val_hat(inputs)
	if (locale === "pt") return pt_val_hat(inputs)
	return ko_val_hat(inputs)
});